import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell, FormInput, PrimaryButton, ErrorBanner, SuccessBanner } from "@/components/auth/AuthShell";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setMsg("");
    if (pw.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (pw !== pw2) { setError("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setMsg("Password updated. Redirecting to sign in…");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Reset your password"
      title="Choose a new password"
      footer={<Link to="/login" className="text-[#D4AF37] hover:underline">← Back to sign in</Link>}
    >
      {!token ? (
        <ErrorBanner message="Missing or invalid reset link. Request a new one from the Forgot password page." />
      ) : (
        <form onSubmit={onSubmit} data-testid="reset-form">
          <ErrorBanner message={error} />
          <SuccessBanner message={msg} />
          <FormInput label="New password" type="password" value={pw} onChange={setPw} placeholder="At least 8 characters" required testId="reset-pw-input" />
          <FormInput label="Confirm new password" type="password" value={pw2} onChange={setPw2} placeholder="Repeat new password" required testId="reset-pw2-input" />
          <PrimaryButton disabled={loading} testId="reset-submit-button">
            {loading ? "Saving…" : "Update Password"}
          </PrimaryButton>
        </form>
      )}
    </AuthShell>
  );
}
